
import * as d3 from 'd3';

import { chartXs, chartSm } from '../../constants';

const heightScale = d3.scale.linear()
    .domain([35, 70])
    .range([10, 20])
    .clamp(true);

export type Config = {
    ticksCount: number;
    ratio: number;
    xs: boolean;
    sm: boolean;
    headingHeight: number;
    rectHeight: number;
    margin: number;
    plotWidth: number;
    height: number;
    boxWidth: number;
    tickHeight: number;
};

export function getConfig(count: number, width: number, _height: number, _margin: number, _ratio: number = 1): Config {
    _ratio = _ratio || 1;

    const plotWidth = width - _margin * 2 * _ratio;

    let ticksCount = 15;
    let ratio = 0.1;
    let xs = false;
    let sm = false;
    let margin = 5 * _ratio;
    if (plotWidth < chartXs * _ratio) {
        ticksCount = 5;
        ratio = .2;
        xs = true;
        margin = 3 * _ratio;
    } else if (plotWidth < chartSm * _ratio) {
        ticksCount = 10;
        ratio = .25;
        sm = true;
    }
    const boxWidth = Math.min(70 * _ratio, ratio * plotWidth);
    const rectHeight = heightScale
        .domain([35 * _ratio, 70 * _ratio])
        .range([10 * _ratio, 20 * _ratio])
        (_height / count);
    const headingHeight = rectHeight;
    const tickHeight = 6 / 20 * rectHeight;
    const axisHeight = tickHeight + (3 * _ratio + tickHeight) + 5 * _ratio;
    const height = rectHeight //rects
        + headingHeight //heading
        + axisHeight //axis
        + 2 * margin;
    return {
        ticksCount,
        ratio,
        xs,
        sm,
        headingHeight,
        rectHeight,
        margin,
        plotWidth,
        height,
        boxWidth,
        tickHeight: tickHeight
    };
}